export type ReportType = "research" | "briefing"
export type ReportSchedule = "once" | "12h" | "daily" | "3d" | "weekly" | "stop"

export const reportTypeOptions: { label: string; value: ReportType }[] = [
  { label: "브리핑", value: "briefing" },
  { label: "리서치 (개발중)", value: "research" },
]

export const scheduleOptions: { label: string; value: ReportSchedule }[] = [
  { label: "지금 한번", value: "once" },
  { label: "멈춤", value: "stop" },
  { label: "12시간", value: "12h" },
  { label: "하루", value: "daily" },
  { label: "3일", value: "3d" },
  { label: "7일", value: "weekly" },
]

// Utility to map schedule code to label
export const getScheduleLabel = (value: ReportSchedule): string => {
  return scheduleOptions.find((opt) => opt.value === value)?.label || value
}

// Utility to map type code to label
export const getReportTypeLabel = (value: ReportType): string => {
  return reportTypeOptions.find((opt) => opt.value === value)?.label || value
}
